export enum VehicleType {
  Car = 'car',
  Camper = 'camper',
  ATV = 'atv',
  Jetski = 'jetski',
  MC = 'mc',
  Smowmobile = 'snowmobile',
  Truck = 'truck',
}
